import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcChevronLeft24 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 24,
	viewBox: "0 0 24 24",
	width: 24,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m15 18c0 .563-.438 1-1 1-.25 0-.5-.125-.688-.313l-6.03-5.968a1.044 1.044 0 0 1 -.282-.719c0-.25.094-.531.281-.719l6.032-5.969c.187-.187.437-.312.687-.312.563 0 1 .438 1 1 0 .281-.094.5-.281.719l-5.281 5.281 5.28 5.281a.99.99 0 0 1 .282.719z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcChevronLeft24;
